// extracted by mini-css-extract-plugin
module.exports = {"ConfirmDelete":"ConfirmDelete_ConfirmDelete__2w3e7","Delete":"ConfirmDelete_Delete__2qmd5"};